import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import {CustomAlert, HoverShowTooltip, HoverHideTooltip} 	from '../../common/_Utilities.jsx';

export default class BDPPurchasingBlock extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
				showPreorderModal: false
			,	showPaymentShippingModal: false
			, showPreorderModal: false
			, doNotShow: false
		}

	}

	render() {
		const {salesInfo, hidePurchase = false} = this.props;
		const userCurrency = blapp.session.idCurrencyDetected;
		const userCountry = blapp.session.codeCountryDetected;

		if(salesInfo) {
			const salesInfoCountryIdx = salesInfo.listPrice.findIndex(item => userCurrency == 2 ? item.codeCountry == userCountry : item.idCurrency == userCurrency);
			const salesInfoUSIdx = salesInfo.listPrice.findIndex(item => item.codeCountry == 'US');

			const priceInfo = salesInfoCountryIdx == -1 ? salesInfo.listPrice[salesInfoUSIdx] : salesInfo.listPrice[salesInfoCountryIdx];
			const countryDetected = salesInfo.listPrice.findIndex(item => item.codeCountry == userCountry);
			const flagTooltip = salesInfoCountryIdx == -1 ? 'Price defaults to USD when you are not in a participating country' : 'Price is based on your current location';
			const flag = <div className="l-margin-right--sm l-flex-no-shrink" data-tooltip={flagTooltip} data-tooltip-width={200} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}><img className="l-block" src={blapp.url2.getCountryFlagUrl(salesInfoCountryIdx == -1 ? 'US' : priceInfo.codeCountry, 'S')}/></div>

			return (
				<React.Fragment>
					<section className="bdp-card__price bdp-card__price--series">
						<div className="l-flex l-center">{flag}<p className="text--title text--bold">{blapp.format.formatMoney(priceInfo.mPrice, salesInfoCountryIdx == -1 ? 'US' : null)}</p></div>
						<p><small className="text--medium text-color--darkest72">Limit 2</small><i className="fal fa-info-circle l-margin-left--sm" data-tooltip={'We restrict the limit a household can buy in order to be fair to all of our fans. If you’ve already reached that limit through previous orders your entire order may be cancelled.'} data-tooltip-width={200} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}/></p>
					</section>
					{(countryDetected == -1 && !hidePurchase) && this.renderNonParticipatingCountry()}
				</React.Fragment>
			);
		}else{
			return false;
		}
	}

	renderNonParticipatingCountry() {
		return (
			<section className="bdp-card__notice">
				<i className="fas fa-exclamation-circle bdp-card__notice-icon"/>
				<p>Based on your current location, we are not able to ship to your country. Read our FAQ for more info on <a href={blapp.url2.getCrowdProjectFAQUrl() + '#participating-countries'}>participating countries</a>.</p>
			</section>
		);
	}
}